<div class="modal-header b p-0">
  <div class="more-ai-matched-card" style="width: 100%;">
    <p>
      <span class="font-weight-500 px-2">JD Fit Insights</span>
    </p>
    <button data-testid="auto-app-jdinsights-modal-button-1"
      type="button"
      class="close py-3 font-weight-normal"
      data-dismiss="modal"
      aria-label="Close"
      (click)="closeModal()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>

<div class="modal-body px-5">
  <div *ngIf="!showLoaderbeforeDataLoad">
  <p class="f-14 font-weight-500">Where the candidate aligns with your job requirements?</p>
  <div class="mb-4">
    <div class="chip-container" >
      <span *ngFor="let common of commonArray">
  <span class="common-match-btn text-capitalize f-12" *ngIf="common?.score >= 7">
          <i class="fa-regular fa-check mr-1 text-success"></i>

   {{common?.key == 'totaltenure' ? 'Total Tenure': common?.key == 'past_experiences' ? 'Past Exp': common?.key?.replace('_',' ')}}
  </span>
  <span class="score-chip text-capitalize f-12" *ngIf="common?.score >= 4 && common?.score < 7">
   {{common?.key == 'totaltenure' ? 'Total Tenure': common?.key == 'past_experiences' ? 'Past Exp': common?.key?.replace('_',' ')}}

  </span>
</span>
</div>
    <p class="f-14 mb-1 summary-ai mt-3" [innerHtml]="formattedText(overallExplanationAlignment)">
     </p>

  </div>
  <hr>
  <div>
    <p class="f-14 mb-2 font-weight-500">Where the candidate differs from your job requirements?</p>
    <div class="chip-container">
  <span class="score-chip text-capitalize f-12" *ngFor="let gap of gapArray">
    {{gap?.key== 'totaltenure' ? 'Total Tenure': gap?.key == 'past_experiences' ? 'Past Exp': gap?.key?.replace('_',' ')}}
  </span>
</div>
    <p  class="f-14 mb-1 mt-3" [innerHtml]="formattedText(overallExplanationdivergence)">
    </p>
</div>
<div class="container mt-4 pl-0">

  <!-- View More Button (top) -->
  <div class="text-center py-2" *ngIf="!showAll">
    <button data-testid="auto-app-jdinsights-modal-button-2" class="btn btn-link p-0 text-webbtree-green f-14" (click)="showMore()">View More <i class="fa-solid fa-angle-down ml-1"></i></button>
  </div>
  <div *ngIf="showAll">
  <!-- Common Section -->
  <div class="border" *ngIf="commonArray?.length">
    <div class="d-flex border-bottom text-center font-weight-bold">
      <div class="col-2 border-right py-2"></div>
      <div class="col-5 border-right py-2">Job Requirements</div>
      <div class="col-5 py-2">{{candidateName | titlecase}}</div>
    </div>

 <div *ngFor="let common of commonArray" class="d-flex border-bottom text-center f-12">

  <div class="col-2 border-right py-2 text-left text-capitalize" [ngClass]="{'comm': common?.score >= 7}">

    <div class="d-flex align-items-center">

      <i class="fa-regular fa-check mr-1 text-success" *ngIf="common?.score >= 7"></i>

      <span class="ml-1">
        {{common?.key == 'totaltenure' ? 'Total Tenure': common?.key == 'past_experiences' ? 'Past Exp': common?.key?.replace('_',' ')}}
      </span>
    </div>
  </div>

  <div class="col-5 border-right py-2 text-left" [innerHTML]="formattedText(jdInsightsResponse[common?.key]?.explanation?.jd_asked)"></div>
  <div class="col-5 py-2 text-left" [innerHTML]="formattedText(jdInsightsResponse[common?.key]?.explanation?.candidate_possession)"></div>
</div>
  </div>

  <!-- Gap Section -->
  <div class="border mt-4" *ngIf="gapArray?.length">

<div *ngFor="let gap of gapArray" class="d-flex border-bottom text-center f-12">

  <div class="col-2 border-right py-2 text-capitalize text-left">

    <div class="d-flex align-items-center">
      <span class="ml-1">
        {{gap?.key == 'totaltenure' ? 'Total Tenure': gap?.key == 'past_experiences' ? 'Past Exp': gap?.key?.replace('_',' ')}}
      </span>
    </div>
  </div>

  <div class="col-5 border-right py-2 text-left" [innerHTML]="formattedText(jdInsightsResponse[gap?.key]?.explanation?.jd_asked)"></div>
  <div class="col-5 py-2 text-left" [innerHTML]="formattedText(jdInsightsResponse[gap?.key]?.explanation?.candidate_possession)"></div>
</div>
  </div>
  </div>


  <!-- View Less Button (bottom) -->
  <div class="text-center py-3" *ngIf="showAll">
    <button data-testid="auto-app-jdinsights-modal-button-3" class="btn btn-link p-0 text-webbtree-green f-14" (click)="showLess()">View Less</button>
  </div>

</div>

  </div>


  <div class="h-50 justify-content-center wccard d-flex flex-column align-items-center" *ngIf="showLoaderbeforeDataLoad">
              <div class="loader text-center" *ngIf="showLoaderbeforeDataLoad">
                <img *ngIf="showLoaderbeforeDataLoad" style="width: 75px;" src="../../assets/rolling-loader.gif" alt="loader" />
              </div>
  </div>

  <!-- <div class="text-center" *ngIf="!showLoaderbeforeDataLoad">
      <div class="text-center">
        <img src="../../assets/similarityInsights.png" alt="img-fluid" class="img-config">
      </div>
      <p class="f-14 font-weight-500 mb-2 text-center">Something went wrong.</p>
    <button data-testid="auto-app-jdinsights-modal-button-4" class="btn-trms-regular criteria-btn mb-2" (click)="getCandidateInsights()">Try again</button>
  </div> -->




</div>
